import React from 'react';
import {localization} from '../../Frames/localization'
import Label from '../../Elements/Label/labels'

import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paginate from '../Pagination/Paginate'

import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';

import MenuItem from '@material-ui/core/MenuItem';
import {materialThemeField} from '../../App'

import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const useStyles = makeStyles({
    });
    function Data(props)
    {
     var rows = 
        props.data.operations.map(item => (
          createData(
            item.date, 
            item.operation.locationIdDesc, 
            item.typeDesc, 
            item.payForm, 
            item.skuIdDesc, 
            item.quantity, 
            item.purePrice, 
            item.pointsAmount,
            item.discount,
            item.amount)
        ))
    
      return rows;
    }
  function createData(date, pointOfSale, type, typePayment, product, number, priceFull, bonus, discount, sum) {
    return { date, pointOfSale, type, typePayment, product, number, priceFull, bonus, discount, sum };
  }
  function SelectCount(props) {
    const classes = useStyles();
      const [state, setState] = React.useState({
          value: props.value,
        });
      const handleChange = name => event => {
        props.setLimit(event.target.value)
          setState({
            ...state,
            [name]: event.target.value,
          });
        };
        const inputLabel = React.useRef(null);
        const [labelWidth, setLabelWidth] = React.useState(0);
        React.useEffect(() => {
          setLabelWidth(inputLabel.current.offsetWidth);
        }, []);
          return (
              <div>
              <FormControl variant={props.variant} className={classes.formControl}>
                <InputLabel ref={inputLabel} htmlFor="outlined-age-native-simple">
                  {props.textLabel}
                </InputLabel>
                <ThemeProvider theme={materialThemeField}>
                <Select             
                    className="ListCountItem"
                    required={props.required}
                    value={state.value}
                    onChange={handleChange('value')}
                    labelWidth={labelWidth}
                    inputProps={{
                      name: 'value',
                      id: 'outlined-age-native-simple',
                    }}
                    >
                      <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={10}>{10}</MenuItem>
                      <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={25}>{25}</MenuItem>
                      <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={100}>{100}</MenuItem>    
                </Select>
                </ThemeProvider>
                </FormControl>
              </div>
          );
      }
  export default function SimpleTable(props) {
    const classes = useStyles();
    var rows = Data(props)
    var tr = {
      Date: localization.GetTranslate('Operations.Date'),
      PointOfSale: localization.GetTranslate('Operations.Point of sale'),
      Type: localization.GetTranslate('Operations.Type'),
      Typeofpayment: localization.GetTranslate('Operations.Type of payment'),
      Product: localization.GetTranslate('Operations.Product'),
      Number: localization.GetTranslate('Operations.Number'),
      Price_without_discount: localization.GetTranslate('Operations.Price without discount'),
      bonuses: localization.GetTranslate('Operations.bonuses'),
      discounts: localization.GetTranslate('Operations.discounts'),
      sum: localization.GetTranslate('Operations.sum')
    }
    var table;
    let myRef = React.createRef();
    const ReactHTMLTableToPDF = () => {
      var FileSaver = require('file-saver');
        let fileName = "operations_pdf.html";
        
        FileSaver.saveAs(new Blob([myRef.current.outerHTML]), fileName, true);
    }
    if(rows.length > 0)
    {
    table = <div>
      <div style={{textAlign: 'left', position: 'absolute', marginTop: -14}}>
        <button 
        className="download-table-button" 
        onClick={ReactHTMLTableToPDF}>
          HTML
        </button>
        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="download-table-button"
          table="table-to-xls"
          filename="operations_xls"
          sheet="tablexls"
          buttonText="XLS"/>
      </div>
    <Table ref={myRef} id="table-to-xls" className={classes.table} aria-label="simple table">
    <TableHead>
        <TableRow>
        <TableCell>{tr.Date}</TableCell>
        <TableCell align="center">{tr.PointOfSale}</TableCell>
        <TableCell align="center">{tr.Type}</TableCell>
        <TableCell align="center">{tr.Typeofpayment}</TableCell>
        <TableCell align="center">{tr.Product}</TableCell>
        <TableCell align="center">{tr.Number}</TableCell>
        <TableCell align="center">{tr.Price_without_discount}</TableCell>
        <TableCell align="center">{tr.bonuses}</TableCell>
        <TableCell align="center">{tr.discounts},&nbsp;грн</TableCell>
        <TableCell align="center">{tr.sum}</TableCell>
        </TableRow>
    </TableHead>
    <TableBody>
        {rows.map(row => (
        <TableRow>
            <TableCell component="th" scope="row">{row.date}</TableCell>
            <TableCell align="center">{row.pointOfSale}</TableCell>
            <TableCell align="center">{row.type}</TableCell>
            <TableCell align="center">{row.typePayment}</TableCell>
            <TableCell align="center">{row.product}</TableCell>
            <TableCell align="center">&#8203;{row.number}</TableCell>
            <TableCell align="center">&#8203;{row.priceFull}</TableCell>
            <TableCell align="center">&#8203;{row.bonus}</TableCell>
            <TableCell align="center">&#8203;{row.discount}</TableCell>
            <TableCell align="center">&#8203;{row.sum}</TableCell>
        </TableRow>
        ))}
    </TableBody>
    </Table>           
    </div>
    }else{
      table = <div className="emptyTableLabel"><Label textLabel={localization.GetTranslate('Operations.emptyTable')} className="emptyTable"></Label></div>
    }
    return (
        <div className={props.className}>
          {table}
          <Paginate 
          page={props.page}
          asyncDisabled={props.asyncDisabled} 
          setPage={props.setPage} 
          data={props.data}></Paginate>
        <div className="SelectCount">
          <SelectCount 
          setLimit={props.setLimit}
          value={props.limit}
          ></SelectCount>
        </div>
        </div>
    );
  }